/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExecutionContext } from "../types/ExecutionContext";
import { ContractSectionsTracker } from "./ContractSectionsTracker";

export class IdleContractSectionsTracker implements ContractSectionsTracker {
	executionContext!: ExecutionContext;

	track(_newSection: string, _newGroup: string): void {
		// intentionally do nothing
	}
}
